import { React, useState, useEffect } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import {
  Button,
  Form,
  Input,
  Row,
  Col,
  Table,
  Modal,
  Image,
  Select,
  Upload,
  Skeleton,
  Spin,
} from 'antd';
import { HttpHandler } from '../../shared/httpHandler';
import {
  EditOutlined,
  DeleteOutlined,
  RocketOutlined,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import secureStorage from '../../shared/secureStorage';
import { encodeBase64Object } from 'shared/common';

const httpHandler = new HttpHandler();

const optionValueMap = {
  A: '鑰匙、車門及電動尾門',
  B: '駕駛座相關操作與設定',
  C: '安全科技配備',
  D: '導航及多媒體影音系統',
};

const TechIntroMaintenance = () => {
  const [optionSearchForm] = Form.useForm();
  const [techIntroSearchForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [techIntroLoading, setTechIntroLoading] = useState(false);
  const [optionTableData, setOptionTableData] = useState([]);
  const [techIntroTableData, setTechIntroTableData] = useState([]);
  const [optionTableParams, setOptionTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const [techIntroTableParams, setTechIntroTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
  });
  const [currentEditType, setCurrentEditType] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedTechIntro, setSelectedTechIntro] = useState({});
  const [optionEditForm] = Form.useForm();
  const [techIntroEditForm] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [isTechIntroCancel, setIsTechIntroCancel] = useState(0);

  const searchOptionData = async () => {
    setOptionTableParams({
      ...optionTableData,
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
    getOptionData({
      current: 1,
      pageSize: 10,
    });
  };

  const searchTechIntroData = async () => {
    setTechIntroTableParams({
      ...techIntroTableData,
      pagination: {
        current: 1,
        pageSize: 50,
      },
    });
    getTechIntroData({
      current: 1,
      pageSize: 50,
    });
  };

  const getOptionData = async (pagination = optionTableParams.pegination) => {
    let { text, value, isOptionCancel } = optionSearchForm.getFieldsValue();
    text = text ? text : '';
    value = value ? value : '';
    isOptionCancel = isOptionCancel ? isOptionCancel : '';
    const { current, pageSize } = pagination;

    const queryString = new URLSearchParams(
      encodeBase64Object({
        text: text,
        value: value,
        is_cancel: isOptionCancel,
        current: current,
        page_size: pageSize,
      })
    ).toString();
    console.log('queryString', queryString);

    const url = `/tech_intro_maintenance/get_option_data?${queryString}`;

    setLoading(true);
    httpHandler.get(url).then((response) => {
      if (response.success) {
        setOptionTableData(response.data);
        setOptionTableParams({
          ...optionTableData,
          pagination: {
            ...pagination,
            total: response.total,
          },
        });
      } else {
        window.antdNotify('錯誤', response.data.message, 'fail');
      }
      setLoading(false);
    });
  };

  const getTechIntroData = async (
    pagination = techIntroTableParams.pagination,
    category = ''
  ) => {
    let { topic, isTechIntroCancel } = techIntroSearchForm.getFieldsValue();
    if (isTechIntroCancel === undefined) {
      isTechIntroCancel = 0;
    }
    topic = topic ? topic : '';
    category = category ? category : '';
    // isTechIntroCancel = isTechIntroCancel ? isTechIntroCancel : 0;
    const { current, pageSize } = pagination;

    const queryString = new URLSearchParams(
      encodeBase64Object({
        topic: topic,
        category: category,
        is_cancel: isTechIntroCancel,
        current: current,
        page_size: pageSize,
      })
    ).toString();

    const url = `/tech_intro_maintenance/get_tech_intro_data?${queryString}`;

    setTechIntroLoading(true);
    httpHandler.get(url).then((response) => {
      if (response.success) {
        setTechIntroTableData(response.data);
        setTechIntroTableParams({
          ...techIntroTableData,
          pagination: {
            ...pagination,
            total: response.total,
          },
        });
      } else {
        window.antdNotify('錯誤', response.data.message, 'fail');
      }
      setTechIntroLoading(false);
    });
  };

  useEffect(() => {
    searchOptionData();
    searchTechIntroData();
  }, []);

  const OptionSearchBar = () => {
    return (
      <>
        <Form
          form={optionSearchForm}
          name="optionSearchForm"
          onFinish={searchOptionData}
          initialValues={{ isOptionCancel: 0 }}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="選項名稱" name="text">
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="配備選項" name="value">
                <Select>
                  {Object.keys(optionValueMap).map((key) => (
                    <Select.Option key={key} value={key}>
                      {optionValueMap[key]}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="狀態" name="isOptionCancel">
                <Select>
                  <Select.Option value="">全部</Select.Option>
                  <Select.Option value={0}>啟用</Select.Option>
                  <Select.Option value={1}>停用</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={16} className="button-group">
              {/* <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => {

                                }}
                                className="button button--register">
                                新增
                            </Button> */}
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
                className="button button--search">
                搜尋
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  };

  const TechIntroSearchBar = () => {
    return (
      <>
        <Form
          form={techIntroSearchForm}
          name="techIntroSearchForm"
          onFinish={searchTechIntroData}
          initialValues={{ isTechIntroCancel: 0 }}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="配備名稱" name="topic">
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="狀態" name="isTechIntroCancel">
                <Select>
                  <Select.Option value="">全部</Select.Option>
                  <Select.Option value={0}>啟用</Select.Option>
                  <Select.Option value={1}>停用</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={16} className="button-group">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setCurrentEditType('新增科技配備項目');
                  techIntroEditForm.resetFields();
                  setIsModalVisible(true);
                }}
                className="button button--register">
                新增
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
                className="button button--search">
                搜尋
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  };

  // 上傳前檢查
  const beforeUpload = (file) => {
    // 檢查檔案類型

    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      window.antdNotify('錯誤', '只能上傳圖片檔案', 'fail');
      return Upload.LIST_IGNORE;
    }
    // 檢查檔案大小
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      window.antdNotify('錯誤', '圖片大小不能超過10MB', 'fail');
      return Upload.LIST_IGNORE;
    }
    return false;
  };
  // 上傳圖片轉base64
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  // 預覽圖片
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewTitle(file.name);
    setPreviewImage(file.preview);
    setPreviewVisible(true);
  };

  const handleRemove = () => {
    setPreviewVisible(false);
    setPreviewImage('');
    setFileList([]);
  };

  const OptionDataTable = () => {
    const columns = [
      // {
      //     title: '編輯',
      //     key: 'editOption',
      //     render: (text, record) => {
      //         return (
      //             <Button
      //                 type="primary"
      //                 icon={<EditOutlined />}
      //                 onClick={() => {
      //                     setSelectedOption(record);
      //                     setCurrentEditType("編輯科技配備分類");
      //                     console.log(`record_in_edit_button: ${JSON.stringify(record, null, 2)}`);
      //                     optionEditForm.setFieldsValue(record);
      //                     optionEditForm.setFieldsValue({ value: optionValueMap[record.value] });
      //                     setIsModalVisible(true);
      //                 }}
      //             >
      //                 編輯分類
      //             </Button>
      //         );
      //     },
      // },
      {
        title: '',
        key: 'optionAction',
        render: (_, record) => (
          <Button onClick={() => handleExpand(record)}>
            {expandedRowKeys.includes(record.id)
              ? '收起配備分類'
              : '展開配備分類'}
          </Button>
        ),
      },
      {
        title: '配備分類',
        dataIndex: 'value',
        key: 'value',
        render: (text) => optionValueMap[text] || text,
      },
      {
        title: '分類排序',
        dataIndex: 'sequence',
        key: 'optionSequence',
      },
      {
        title: '建立時間',
        dataIndex: 'create_time',
        key: 'optionCreateTime',
      },
      {
        title: '狀態',
        dataIndex: 'is_cancel',
        key: 'optionIsCancel',
        render: (text) => {
          if (text === 0) return '啟用中';
          if (text === 1) return '非啟用';
          return '全部';
        },
      },
    ];

    const handleExpand = async (record) => {
      setSelectedOption(record);
      setExpandedRowKeys((prevExpandedRowKeys) => {
        if (prevExpandedRowKeys.includes(record.id)) {
          return prevExpandedRowKeys.filter((key) => key !== record.id);
        } else {
          return [...prevExpandedRowKeys, record.id];
        }
      });
    };

    const expandedRowRender = (record) => {
      // const expandedColumns = [
      //     { title: '子選項名稱', dataIndex: 'sub_option_name', key: 'sub_option_name' },
      //     { title: '子選項值', dataIndex: 'sub_option_value', key: 'sub_option_value' },
      //     // 其他子表格欄位
      // ];

      const filteredData = techIntroTableData.filter(
        (item) => item.category === record.value
      );

      const columns = [
        {
          title: '編輯',
          key: 'editTechIntro',
          render: (text, record) => {
            return (
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => {
                  setSelectedTechIntro(record);
                  setCurrentEditType('編輯科技配備項目');
                  techIntroEditForm.setFieldsValue(record);
                  setIsModalVisible(true);
                }}>
                編輯配備
              </Button>
            );
          },
        },
        {
          title: '配備圖片',
          dataIndex: 'image',
          key: 'image',
          render: (text, record) => {
            const { image, image_extension } = record;
            if (image && image_extension) {
              return (
                <img
                  src={`data:image/${image_extension};base64,${image}`}
                  alt="配備圖片"
                  style={{ width: '100px' }}
                />
              );
            } else {
              return '無圖片';
            }
          },
        },
        {
          title: '配備名稱',
          dataIndex: 'topic',
          key: 'topic',
        },
        {
          title: '顯示排序',
          dataIndex: 'sequence',
          key: 'techIntroSequence',
        },
        {
          title: '建立時間',
          dataIndex: 'create_time',
          key: 'techCreateTime',
        },
        {
          title: '啟用狀態',
          dataIndex: 'is_cancel',
          key: 'is_cancel',
          render: (text) => {
            if (text === 0) return '啟用中';
            if (text === 1) return '非啟用';
            return '全部';
          },
        },
      ];

      return (
        <div>
          <TechIntroSearchBar
            form={techIntroSearchForm}
            onFinish={searchTechIntroData}
          />
          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={false}
            loading={techIntroLoading}
          />
        </div>
      );
    };

    return (
      <Table
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={optionTableData}
        pagination={optionTableParams.pagination}
        loading={loading}
        onChange={(pagination) => {
          setOptionTableParams({
            ...optionTableParams,
            pagination,
          });
          searchOptionData();
        }}
        expandable={{
          expandedRowRender,
          expandedRowKeys,
          // onExpand: (expanded, record) => handleExpand(record),
          expandIconColumnIndex: -1, // 隱藏默認的展開按鈕
          expandIcon: () => null,
        }}
      />
    );
  };

  const EditModal = () => {
    const editData = selectedOption;

    const showConfirm = () => {
      Modal.confirm({
        title: `確認${currentEditType}`,
        content: `你確定要儲存這些變更嗎？`,
        okText: '確定',
        cancelText: '取消',
        onOk() {
          editModalSubmitHandler();
        },
        onCancel() {
          console.log('取消儲存');
        },
      });
    };

    const handleUploadChange = ({ fileList }) => {
      setFileList(fileList);

      // 檢查文件是否上傳完成
      fileList.forEach((file) => {
        handlePreview(file);
      });
    };

    return (
      <Modal
        width="50%"
        title={`${currentEditType}`}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setSelectedOption({});
          setSelectedTechIntro({});
          setCurrentEditType('');
          optionEditForm.resetFields();
          techIntroEditForm.resetFields();
        }}
        footer={[
          <Button
            key="close"
            onClick={() => {
              setIsModalVisible(false);
              setSelectedOption({});
            }}>
            關閉
          </Button>,
          <Button
            key="save"
            type="primary"
            onClick={() => {
              showConfirm();
            }}>
            儲存
          </Button>,
        ]}>
        {/* <Form form={optionSearchForm} name="optionSearchForm">
                    <Form.Item label="選項" name="value">
                        <Select>
                            {Object.keys(optionValueMap).map((key) => (
                                <Select.Option key={key} value={key}>
                                    {optionValueMap[key]}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="選項排序" name="sequence">
                        <Input />
                    </Form.Item>
                    <Form.Item label="狀態" name="is_cancel">
                        <Select>
                            <Select.Option value="0">啟用</Select.Option>
                            <Select.Option value="1">停用</Select.Option>
                        </Select>
                    </Form.Item>
                </Form> */}
        {currentEditType === '編輯科技配備分類' && (
          <Form form={optionEditForm} name="optionEditForm">
            <Form.Item label="分類名稱" name="value">
              <Input />
            </Form.Item>
            <Form.Item label="分類排序" name="sequence">
              <Input />
            </Form.Item>
            <Form.Item label="分類狀態" name="is_cancel">
              <Select>
                <Select.Option value={0}>啟用</Select.Option>
                <Select.Option value={1}>停用</Select.Option>
              </Select>
            </Form.Item>
          </Form>
        )}
        {currentEditType === '編輯科技配備項目' && (
          <Form form={techIntroEditForm} name="techIntroEditForm">
            <Form.Item label="配備名稱" name="topic">
              <Input />
            </Form.Item>
            <Form.Item label="配備圖片" name="image">
              {previewVisible && (
                <Image
                  src={previewImage}
                  alt="Upload Image"
                  style={{
                    // width: '100%',
                    height: '100%',
                  }}
                />
              )}
              <Upload
                name="techIntroImage"
                listType="picture"
                fileList={fileList}
                beforeUpload={beforeUpload}
                onPreview={handlePreview}
                onChange={handleUploadChange}
                onRemove={handleRemove}
                // showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>上傳圖片</Button>
              </Upload>
            </Form.Item>
            <Form.Item label="Youtube 連結" name="youtube_url">
              <Input />
            </Form.Item>
            <Form.Item label="配備排序" name="sequence">
              <Input />
            </Form.Item>
            <Form.Item label="配備狀態" name="is_cancel">
              <Select>
                <Select.Option value={0}>啟用</Select.Option>
                <Select.Option value={1}>停用</Select.Option>
              </Select>
            </Form.Item>
          </Form>
        )}
        {currentEditType === '新增科技配備項目' && (
          <Form form={techIntroEditForm} name="techIntroEditForm">
            <Form.Item label="配備名稱" name="topic">
              <Input />
            </Form.Item>
            <Form.Item label="配備圖片" name="image">
              {previewVisible && (
                <Image
                  src={previewImage}
                  alt="Upload Image"
                  style={{
                    // width: '100%',
                    height: '100%',
                  }}
                />
              )}
              <Upload
                name="techIntroImage"
                listType="picture"
                fileList={fileList}
                beforeUpload={beforeUpload}
                onPreview={handlePreview}
                onChange={handleUploadChange}
                onRemove={handleRemove}
                // showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>上傳圖片</Button>
              </Upload>
            </Form.Item>
            <Form.Item label="Youtube 連結" name="youtube_url">
              <Input />
            </Form.Item>
            <Form.Item label="配備排序" name="sequence">
              <Input />
            </Form.Item>
            {/* <Form.Item label="配備狀態" name="is_cancel">
                            <Select>
                                <Select.Option value={0}>啟用</Select.Option>
                                <Select.Option value={1}>停用</Select.Option>
                            </Select>
                        </Form.Item> */}
          </Form>
        )}
      </Modal>
    );
  };

  const editModalSubmitHandler = async () => {
    if (currentEditType === '編輯科技配備分類') {
      const submitData = optionEditForm.getFieldsValue();
      const postData = {
        id: selectedOption.id,
        group: 'tech_intro',
        code: 'category',
        text: submitData.value,
        value: selectedOption.value,
        is_cancel: submitData.is_cancel,
        sequence: submitData.sequence,
        update_user: secureStorage.getItem('userId'),
        cancel_user:
          submitData.is_cancel === 1 ? secureStorage.getItem('userId') : null,
      };
      httpHandler
        .post('/tech_intro_maintenance/update_option_data', postData)
        .then((response) => {
          if (response.success) {
            window.antdNotify('成功', '編輯科技配備分類成功', 'success');
            searchOptionData();
            setIsModalVisible(false);
            setSelectedOption({});
            optionEditForm.resetFields();
          } else {
            window.antdNotify('錯誤', response.message, 'fail');
          }
        });
    } else if (currentEditType === '編輯科技配備項目') {
      const submitData = techIntroEditForm.getFieldsValue();

      let binaryData = null;
      let extension = null;

      if (submitData.image && submitData.image.fileList.length > 0) {
        try {
          binaryData = await getBase64(
            submitData.image.fileList[0].originFileObj
          );
          extension = submitData.image.fileList[0].name.split('.').pop();
        } catch (error) {
          console.error('Error reading file:', error);
        }
      }

      const postData = {
        topic: submitData.topic,
        youtube_url: submitData.youtube_url,
        uid: selectedTechIntro.uid,
        update_user: secureStorage.getItem('userId'),
        is_cancel: submitData.is_cancel,
        cancel_user:
          submitData.is_cancel === 1 ? secureStorage.getItem('userId') : null,
        category: selectedTechIntro.category,
        sequence: submitData.sequence,
        image: binaryData ? binaryData : selectedTechIntro.image,
        image_extension: extension
          ? extension
          : selectedTechIntro.image_extension,
      };
      httpHandler
        .post('/tech_intro_maintenance/update_tech_intro_data', postData)
        .then((response) => {
          if (response.success) {
            window.antdNotify('成功', '編輯科技配備項目成功', 'success');
            searchTechIntroData();
            setIsModalVisible(false);
            setSelectedTechIntro({});
            setPreviewImage('');
            setPreviewTitle('');
            setFileList([]);
            techIntroEditForm.resetFields();
          } else {
            window.antdNotify('錯誤', response.message, 'fail');
          }
        });
    } else if (currentEditType === '新增科技配備項目') {
      const submitData = techIntroEditForm.getFieldsValue();
      let binaryData = null;
      let extension = null;

      if (submitData.image && submitData.image.fileList.length > 0) {
        try {
          binaryData = await getBase64(
            submitData.image.fileList[0].originFileObj
          );
          extension = submitData.image.fileList[0].name.split('.').pop();
        } catch (error) {
          console.error('Error reading file:', error);
        }
      }

      const postData = {
        topic: submitData.topic,
        youtube_url: submitData.youtube_url,
        category: selectedOption.value,
        sequence: submitData.sequence,
        create_user: secureStorage.getItem('userId'),
        image_extension: extension,
        image: binaryData,
      };

      httpHandler
        .post('/tech_intro_maintenance/insert_tech_intro_data', postData)
        .then((response) => {
          if (response.success) {
            window.antdNotify('成功', '新增科技配備項目成功', 'success');
            searchTechIntroData();
            setIsModalVisible(false);
            setSelectedTechIntro({});
            setPreviewImage('');
            setPreviewTitle('');
            setFileList([]);
            techIntroEditForm.resetFields();
          } else {
            window.antdNotify('錯誤', response.message, 'fail');
          }
        });
    }
  };

  const section = [
    {
      hasTitle: false,
      title: 'Search',
      children: <OptionSearchBar />,
    },
    {
      hasTitle: false,
      title: 'Search',
      children: <OptionDataTable />,
    },
    {
      hasTitle: false,
      title: 'Edit and Modal',
      children: <EditModal loading={loading} />,
    },
  ];

  return (
    <>
      <PageHeader functionName={'lexus_techintro'}></PageHeader>
      <PageBody section={section}></PageBody>
    </>
  );
};

export default TechIntroMaintenance;
